import script from "./PartnerInquiry.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerInquiry.vue?vue&type=script&setup=true&lang=js"

import "./PartnerInquiry.vue?vue&type=style&index=0&id=d8b2a220&scoped=true&lang=css"
import "./PartnerInquiry.vue?vue&type=style&index=1&id=d8b2a220&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8b2a220"]])

export default __exports__